export const LARGEST_PRIZE_VALUE = 200000;